export const contactSliderOptions = (instance, options) => {
    return {
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        pagination: false
    }
}